import React, { useState } from 'react';
import { Grid, Typography, IconButton, Button, CircularProgress, Chip, TextField } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { useStyle as onboardingStyle } from '../..';
import { CustomerServices } from '../../../../Services/CustomerServices';
import { ProjectServices } from '../../../../Services/ProjectServices';
import { IsNumeric, notify } from 'utils';
import { useParams } from 'react-router';
import variables from '../../../../Sys/variable.scss';
import { Autocomplete } from '@material-ui/lab';
import Assesments from 'Pages/MyAssesssments';

const customerServices = new CustomerServices();
const projectServices = new ProjectServices();

const useStyles = makeStyles((theme) => ({
    root: {
        border: '1px solid #D6D6D6',
        borderRadius: 5,
        backgroundColor: variables.headerColor,
        width: '100%',
        minHeight: 350,
        display: 'flex',
        flexDirection: 'column',
    },
    cardContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    numberInputBottom: {
        marginTop: 'auto',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 15,
        fontWeight: 700,
        lineHeight: "18px",
        color: variables.darkThemeText
    },
    pos: {
        marginBottom: 12,
    },
    buttonWrap: {
        width: '100%',
        textAlign: 'center',
        margin: '6px auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8
    },
    apprenticeshipButtonWrap: {
        width: '100%',
        textAlign: 'center',
        margin: '10px auto 6px'
    },
    removeBtn: {
        background: '#E23A3A',
        color: '#fff',
        height: 32,
        width: 32,
        padding: 0,
        borderRadius: '50%',
        '&:hover': {
            background: '#c20b0b',
            color: '#fff'
        }
    },
    addBtn: {
        height: 32,
        width: 32,
        padding: 0,
        borderRadius: '50%'
    },
    noHeading: {
        color: variables.darkThemeText,
        fontWeight: 400,
        fontSize: '10px',
        lineHeight: '12px',
        marginTop: 15
    },
    noOfItemWrap: {
        display: "flex",
        width: "100%",
        marginTop: 20
    },
    inputStyle: {
        minWidth: 130,
        width: '100%',
        marginTop: 16,
        marginLeft: 0
    },
    itemContain: {
        display: 'flex',
        flexDirection: 'column',
    },
    cardGridItem: {
        display: 'flex',
        flexDirection: 'column',
    },
    sectionLoaderWrap: {
        minHeight: 280,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

export const AddMoreButton = ({ handleAddNew, action, disabled = false }) => {
    const classes = useStyles();
    return (
        <IconButton onClick={(evt) => {
            handleAddNew(action);
        }}
            className={classes.addBtn}
            aria-label={`add to more ${action}`}
            disabled={disabled}>
            <AddCircleIcon style={{ color: disabled ? "#B0B0B0" : "#07AD17", fontSize: '2.2rem' }} />
        </IconButton>
    )
}

export const RemoveButton = ({ handleClick, action, index }) => {
    const classes = useStyles();
    return (
        <IconButton
            onClick={(evt) => handleClick(action, index)}
            className={classes.removeBtn}
            aria-label={`remove ${action}`}
        >
            <HighlightOffIcon style={{ fontSize: '2.2rem' }} />
        </IconButton>
    )
}

export const NumberInput = ({ handleChange, value, index, action, maxNum, name, disabled }) => {
    const classes = useStyles();
    let inpuProps = { disableUnderline: true };
    if (maxNum !== null) {
        inpuProps.max = maxNum;
    }
    return (
        <div className={classes.noOfItemWrap}>
            <TextField
                variant="outlined"
                size="small"
                fullWidth
                label="Number of licenses"
                value={value}
                type="text"
                disabled={disabled || false}
                inputProps={{ ...inpuProps }}
                className={classes.inputStyle}
                name={name || "total_count"}
                onChange={evt => {
                    if (evt.target.value && !IsNumeric(evt.target.value)) {
                        return null;
                    }
                    handleChange(evt, index, action);
                }}
            />
        </div>
    );
}

export const initAssignLicenseFields = {
    assessments: [{ assessment_id: '', count: 0, total_count: 0, user_count: 0, maxCount: 0 }],
    courses: [{ course_id: '', count: 0, total_count: 0, provider: '', user_count: 0, maxCount: 0 }],
    apprenticeships: [{ apprenticeship_id: '', count: 0, total_count: 0, user_count: 0, maxCount: 0 }],
    labs: [{ lab_id: '', count: 0, name: '', total_count: 0, course_id: '', user_count: 0 }]
};

const initUserFields = {
    status: 'Open',
    project_name: '',
    company_id: '',
    company_admin_id: '',
    project_admin: '',
    description: ''
};

const AssignLicence = ({
    activeStep,
    handleBack,
    handleNext,
    apprenticeshipList,
    coursesList,
    assessmentList
}) => {

    const classes = useStyles();
    const onBorningClasses = onboardingStyle();
    const { id } = useParams();

    const [assignLicenseForm, setAssignLicenseForm] = useState({ ...initAssignLicenseFields });
    const [submitLoading, setSubmitLoading] = useState(false);
    const [user, setUser] = useState({ ...initUserFields });
    const [removeCourses, setRemoveCourses] = useState([]);
    const [removeApprenticeships, setRemoveApprenticeships] = useState([]);
    const [removeAssessments, setRemoveAssessments] = useState([]);
    const [existingLicence, setExistingLicence] = useState({ courses: [], assessments: [], apprenticeships: [] });
    const [removeLabs, setRemoveLabs] = useState([]);
    const [providersList, setProvidersList] = useState([]);
    const [providerCourseOptions, setProviderCourseOptions] = useState({});
    const [coursesFromAssignLicense, setCoursesFromAssignLicense] = useState([]);
    const [initialLoading, setInitialLoading] = useState(true);
    const [providerLoading, setProviderLoading] = useState(false);

    React.useEffect(() => {
        getProjectDetails().finally(() => {
            setInitialLoading(false);
        });
    }, []);

    async function getProjectDetails() {
        const projectDetails = await projectServices.getProjectDetails(id || localStorage.getItem('cstmsrSaveFlow'));
        const reponseData = projectDetails?.data || projectDetails;
        if (reponseData) {
            const otherData = projectDetails?.other_data || reponseData?.other_data || {};
            const providers = otherData.providers || [];
            const allCoursesForProviders = otherData.course || [];

            setProvidersList(Array.isArray(providers) ? providers : []);

            // build initial mapping of provider -> courses for existing cards
            if (Array.isArray(allCoursesForProviders) && allCoursesForProviders.length) {
                const initialProviderCourseMap = {};
                const dropdownCourseOptions = allCoursesForProviders.map(cs => ({
                    id: cs.uuid,
                    name: (cs.provider === 'Xpert Skills') ? `${cs.name} - ${cs.provider}` : cs.name,
                    provider: cs.provider,
                    ...cs
                }));
                setCoursesFromAssignLicense(dropdownCourseOptions);
                allCoursesForProviders.forEach(cs => {
                    const providerName = cs?.provider;
                    if (!providerName) return;
                    if (!initialProviderCourseMap[providerName]) {
                        initialProviderCourseMap[providerName] = [];
                    }
                    initialProviderCourseMap[providerName].push({
                        id: cs.uuid,
                        name: cs.name,
                        provider: cs.provider,
                        ...cs
                    });
                });
                setProviderCourseOptions(initialProviderCourseMap);
            }
            const { assessment, apprenticeship, course, lab } = reponseData;
            let courseIds = [];
            let assesmentIds = [];
            let apprenticeshipIds = [];
            const courseArray = (course && course.length > 0)
                ? course
                : assignLicenseForm.courses;
            const courseResult = [];
            courseArray.map(item => {
                courseResult.push({
                    course_id: { id: item.uuid, name: (item.provider === 'Xpert Skills') ? `${item.name} - ${item.provider}` : item.name },
                    count: item.count ? parseInt(item.count) : 0,
                    provider: item.provider || '',
                    ...item
                });
                courseIds.push(item.uuid);
            });
            let assessments = (assessment && assessment?.length) ?
                assessment.map(itm => {
                    assesmentIds.push(itm.uuid);
                    return ({
                        assessment_id: itm,
                        count: parseInt(itm.count),
                        ...itm
                    });
                }) : assignLicenseForm.assessments;
            let apprenticeships = (apprenticeship && apprenticeship?.length) ?
                apprenticeship.map(itm => {
                    apprenticeshipIds.push(itm.uuid);
                    return ({
                        apprenticeship_id: itm,
                        count: parseInt(itm.count),
                        ...itm
                    });
                }) : assignLicenseForm.apprenticeships;
            const xpertSkillsLabs = await projectServices.getLabsByCourse({ course_ids: courseIds });
            let labs = (lab && lab?.length) ?
                lab.map(itm => {
                    const selectedLab = (xpertSkillsLabs?.data) && xpertSkillsLabs.data.find(lb => lb?.uuid === itm?.uuid);
                    return {
                        lab_id: itm,
                        course_id: selectedLab?.course_id || '',
                        count: parseInt(itm.count),
                        ...itm
                    }
                }) : assignLicenseForm.labs;
            setUser({
                project_name: reponseData.project_name,
                status: reponseData?.status || "Open",
                description: reponseData.description,
                company_id: reponseData.company_id,
                company_admin_id: reponseData.company_admin_id,
                project_admin: reponseData.project_admin
            });
            if (!lab.length) {
                if (xpertSkillsLabs?.data) {
                    const selectedLabs = (xpertSkillsLabs?.data.length) ? xpertSkillsLabs?.data.map(itm => {
                        let selectedCourse = courseResult.find(crs => crs?.course_id?.id === itm?.course_id);
                        return {
                            lab_id: { id: itm.uuid, name: itm.name },
                            name: itm.name,
                            count: selectedCourse?.count || 0,
                            course_id: itm?.course_id || '',
                            total_count: selectedCourse?.total_count || 0
                        };
                    }) : [...initAssignLicenseFields.labs];
                    labs = selectedLabs;
                }
            }
            setExistingLicence({ courses: courseIds, assessments: assesmentIds, apprenticeships: apprenticeshipIds });
            setAssignLicenseForm({ labs: labs, courses: courseResult, assessments: assessments, apprenticeships: apprenticeships });

        }
    }

    const loadCoursesForProvider = async (providerName) => {
        if (!providerName) {
            return [];
        }

        if (providerCourseOptions[providerName]) {
            return providerCourseOptions[providerName];
        }

        setProviderLoading(true);
        try {
            const projectDetails = await projectServices.getProjectDetails(id || localStorage.getItem('cstmsrSaveFlow'), providerName);
            const reponseData = projectDetails?.data || projectDetails;
            const allCourses = (projectDetails?.other_data?.course || reponseData?.other_data?.course) || [];

            const mappedCourses = allCourses
                .filter(cs => cs?.provider === providerName)
                .map(cs => ({
                    id: cs.uuid,
                    name: cs.name,
                    provider: cs.provider,
                    ...cs
                }));

            setProviderCourseOptions(prev => ({
                ...prev,
                [providerName]: mappedCourses
            }));

            return mappedCourses;
        } finally {
            setProviderLoading(false);
        }
    };

    const handleChangeInput = (e, idx, type) => {
        const { name, value } = e.target;
        let newVal = value;
        if (name === 'total_count') {
            newVal = value ? parseInt(value) : 0;
        }
        setAssignLicenseForm((prevState) => {
            let newState = { ...prevState };
            let prvData = [...newState[type]];
            prvData[idx] = { ...prvData[idx], [name]: newVal };
            newState[type] = prvData;
            return newState;
        });
    };

    const handleChangeAutoComplete = (value, idx, type, name) => {
        const newVal = value;
        setAssignLicenseForm((prevState) => {
            let newState = { ...prevState };
            let prvData = [...newState[type]];
            prvData[idx] = { ...prvData[idx], [name]: newVal };
            newState[type] = prvData;
            return newState;
        });
    };

    const handleRemoveAssignLicence = (type, idx) => {
        let checkExist = assignLicenseForm?.[type]?.[idx];
        let checkKey = (type === 'courses') ? 'course_id' : (type === 'apprenticeships') ? 'apprenticeship_id' : (type === 'assessments') ? 'assessment_id' : '';
        if (checkKey && checkExist[checkKey] && existingLicence[type].includes(checkExist[checkKey]?.id || checkExist[checkKey]?.uuid)) {
            if (type === 'courses') {
                setRemoveCourses([...removeCourses, checkExist?.course_id?.id]);
            } else if (type === 'apprenticeships') {
                setRemoveApprenticeships([...removeApprenticeships, checkExist?.apprenticeship_id?.uuid]);
            } else if (type === 'assessments') {
                setRemoveAssessments([...removeAssessments, checkExist?.assessment_id?.uuid]);
            }
        }
        if (type === 'courses') {
            autoSelectLabsByCourse(null, idx, 'remove');
        } else {
            setAssignLicenseForm((prevState) => {
                let newState = { ...prevState };
                let prvData = newState[type];
                prvData.splice(idx, 1);
                newState[type] = (prvData?.length) ? prvData : [...initAssignLicenseFields[type]];
                return newState;
            });
        }
    }

    const handleAddAssignLicence = (type) => {
        setAssignLicenseForm((prevState) => {
            let newState = { ...prevState };
            let prvData = [...newState[type]];
            prvData.push({ ...initAssignLicenseFields[type][0] });
            newState[type] = prvData;
            return newState;
        });
    }

    const autoSelectLabsByCourse = async (course, indx, action = 'add') => {
        let removeCourse = (course === null && assignLicenseForm.courses.length) ? { ...assignLicenseForm.courses[indx] } : null;
        const courseIds = (removeCourse && removeCourse?.course_id) ? [removeCourse?.course_id?.id] : (course?.id) ? [course?.id] : [];
        let selectedLabs = (assignLicenseForm.labs.length && assignLicenseForm.labs[0].lab_id) ? [...assignLicenseForm.labs] : [];
        let removeLabIds = [...removeLabs];
        if ((course && course?.name?.includes('Xpert Skills')) || (removeCourse && removeCourse?.course_id && removeCourse.course_id?.name?.includes('Xpert Skills'))) {
            if (action === 'add') {
                const courseLabs = await projectServices.getLabsByCourse({ course_ids: courseIds });
                if (courseLabs?.data) {
                    courseLabs?.data.forEach(itm => {
                        let selectedCourse = { ...course };
                        selectedLabs.push({
                            lab_id: { id: itm.uuid, name: itm.name },
                            name: itm.name,
                            count: selectedCourse?.count || 0,
                            total_count: selectedCourse?.total_count || 0,
                            course_id: itm?.course_id || ''
                        });
                    });
                }
            } else {
                if (removeCourse && removeCourse.course_id) {
                    let removeLabsIndex = [];
                    assignLicenseForm.labs.map((lab, idx) => {
                        if (lab.course_id === removeCourse.course_id?.id) {
                            removeLabsIndex.push(idx);
                            removeLabIds.push(lab?.uuid);
                        }
                    });
                    const indexSet = new Set(removeLabsIndex);
                    selectedLabs = selectedLabs.filter((value, i) => !indexSet.has(i));
                    setRemoveLabs(removeLabIds);
                }
            }
        }
        setAssignLicenseForm((prevState) => {
            let newState = { ...prevState };
            let prvData = [...newState.courses];
            if (action === 'add') {
                prvData[indx] = {
                    ...prvData[indx],
                    course_id: course,
                    // pre-populate provider from selected course object when available
                    provider: course?.provider || prvData[indx]?.provider || ''
                };
            } else {
                prvData.splice(indx, 1);
            }
            newState.labs = (selectedLabs.length) ? [...selectedLabs] : [...initAssignLicenseFields.labs];
            newState.courses = (prvData.length) ? prvData : [...initAssignLicenseFields.courses];
            return newState;
        });
    }

    const getAssessments = () => {
        return (
            assignLicenseForm.assessments.map((item, key) => (
                <div key={`assisment-${key}`} className={classes.itemContain} style={key > 0 ? { marginTop: 8 } : null}>
                    <Card className={classes.root}>
                        <CardContent className={classes.cardContent}>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                Assessments Allocated : {item.count} / {item.total_count}
                            </Typography>
                            <Autocomplete
                                id="tags-outlined"
                                value={item.assessment_id || null}
                                name="assessment_id"
                                options={assessmentList}
                                getOptionLabel={option => option.name}
                                onChange={(event, newValue) => {
                                    let check = assignLicenseForm.assessments.find(cr => (cr?.assessment_id?.uuid === newValue?.uuid && newValue?.uuid));
                                    if (check) {
                                        notify('error', `This assessment is already selected!`);
                                        return null;
                                    }
                                    handleChangeAutoComplete(newValue, key, 'assessments', 'assessment_id');
                                }}
                                style={{ marginTop: 36, marginBottom: 45 }}
                                limitTags={2}
                                renderTags={(value, getTagProps) => value.map((option, index) => (
                                    <Chip variant="outlined" size="small" label={option.name} {...getTagProps({ index })} />
                                ))}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        label="Select Assessments"
                                    />
                                )}
                            />
                            <div className={classes.numberInputBottom}>
                                <NumberInput
                                    value={item.total_count ? parseInt(item.total_count) : 0}
                                    index={key}
                                    maxNum={null}
                                    action="assessments"
                                    handleChange={handleChangeInput}
                                />
                            </div>
                        </CardContent>
                    </Card>
                    <div className={classes.buttonWrap}>
                        {key === (assignLicenseForm.assessments.length - 1) && <AddMoreButton action={'assessments'} handleAddNew={handleAddAssignLicence} />}
                        {<RemoveButton action={'assessments'} index={key} handleClick={handleRemoveAssignLicence} />}
                    </div>
                </div>
            ))
        )
    }

    const getCourses = () => {
        return (
            assignLicenseForm.courses.map((item, key) => (
                <div key={`course-${key}`} className={classes.itemContain} style={key > 0 ? { marginTop: 8 } : null}>
                    <Card className={classes.root}>
                        <CardContent className={classes.cardContent}>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                Courses Allocated : {item.count} / {item.total_count}
                            </Typography>
                            <Autocomplete
                                id="provider-autocomplete"
                                value={item.provider || null}
                                name="provider"
                                options={providersList}
                                getOptionLabel={(option) => (typeof option === 'string' ? option : option) || ''}
                                onChange={async (event, newValue) => {
                                    const providerName = newValue || '';
                                    // update provider value on the row
                                    setAssignLicenseForm(prevState => {
                                        const newState = { ...prevState };
                                        const courses = [...newState.courses];
                                        const current = courses[key] || {};
                                        courses[key] = {
                                            ...current,
                                            provider: providerName,
                                            course_id: '' // reset selected course when provider changes
                                        };
                                        newState.courses = courses;
                                        return newState;
                                    });
                                    if (providerName) {
                                        await loadCoursesForProvider(providerName);
                                    }
                                }}
                                style={{ marginTop: 36, marginBottom: 12 }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        label="Select Provider"
                                    />
                                )}
                            />
                            <Autocomplete
                                id="tags-outlined"
                                value={item.course_id || null}
                                name="course_id"
                                options={(item.provider && providerCourseOptions[item.provider]) ? providerCourseOptions[item.provider] : (coursesFromAssignLicense.length ? coursesFromAssignLicense : coursesList)}
                                getOptionLabel={option => option.name}
                                onChange={(event, newValue) => {
                                    let check = assignLicenseForm.courses.find(cr => cr?.course_id?.id === newValue?.id && newValue?.id);
                                    if (check) {
                                        notify('error', `This course is already selected!`);
                                        return null;
                                    }
                                    return autoSelectLabsByCourse(newValue, key, 'add');
                                }}
                                style={{ marginTop: 12, marginBottom: 45 }}
                                limitTags={2}
                                renderTags={(value, getTagProps) => value.map((option, index) => (
                                    <Chip variant="outlined" size="small" label={option.name} {...getTagProps({ index })} />
                                ))}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        label="Select Courses"
                                    />
                                )}
                            />
                            <div className={classes.numberInputBottom}>
                                <NumberInput
                                    value={item.total_count ? parseInt(item.total_count) : 0}
                                    index={key}
                                    maxNum={null}
                                    action="courses"
                                    handleChange={handleChangeInput}
                                />
                            </div>
                        </CardContent>
                    </Card>
                    <div className={classes.buttonWrap}>
                        {key === (assignLicenseForm.courses.length - 1) && <AddMoreButton action={'courses'} handleAddNew={handleAddAssignLicence} />}
                        {<RemoveButton index={key} action={'courses'} handleClick={handleRemoveAssignLicence} />}
                    </div>
                </div>
            ))
        )
    }

    const getApprenticeships = () => {
        return (
            assignLicenseForm.apprenticeships.map((item, key) => (
                <div key={`assisment-${key}`} className={classes.itemContain} style={key > 0 ? { marginTop: 8 } : null}>
                    <Card className={classes.root}>
                        <CardContent className={classes.cardContent}>
                            {/* {key === 0 && */}
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                Apprenticeships Allocated : {item.count} / {item.total_count}
                            </Typography>
                            <Autocomplete
                                id="tags-outlined"
                                value={item.apprenticeship_id || null}
                                name="apprenticeship_id"
                                options={apprenticeshipList}
                                getOptionLabel={option => option.name}
                                onChange={(event, newValue) => {
                                    let check = assignLicenseForm.apprenticeships.find(cr => (cr?.apprenticeship_id?.uuid === newValue?.uuid && newValue?.uuid));
                                    if (check) {
                                        notify('error', `This apprenticeship is already selected!`);
                                        return null;
                                    }
                                    return handleChangeAutoComplete(newValue, key, 'apprenticeships', 'apprenticeship_id');
                                }}
                                style={{ marginTop: 36, marginBottom: 45 }}
                                limitTags={2}
                                renderTags={(value, getTagProps) => value.map((option, index) => (
                                    <Chip variant="outlined" size="small" label={option.name} {...getTagProps({ index })} />
                                ))}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        label="Select Apprenticeships"
                                    />
                                )}
                            />
                            <div className={classes.numberInputBottom}>
                                <NumberInput
                                    value={item.total_count ? parseInt(item.total_count) : 0}
                                    index={key}
                                    maxNum={null}
                                    action="apprenticeships"
                                    handleChange={handleChangeInput}
                                />
                            </div>
                        </CardContent>
                    </Card>
                    <div className={classes.apprenticeshipButtonWrap}>
                        {/* {key === (assignLicenseForm.apprenticeships.length -1) && <AddMoreButton action={'apprenticeships'} handleAddNew={handleAddAssignLicence} />} */}
                        {<RemoveButton index={key} action={'apprenticeships'} handleClick={handleRemoveAssignLicence} />}
                    </div>
                </div>
            ))
        )
    }

    const getLabs = () => {
        return (assignLicenseForm.labs.map((item, key) => (
            <div key={`labs-${key}`} className={classes.itemContain} style={key > 0 ? { marginTop: 8 } : null}>
                <Card className={classes.root}>
                    <CardContent className={classes.cardContent}>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Labs Allocated : {item.count} / {item?.total_count || 0}
                        </Typography>
                        <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            label="Select Labs"
                            value={item.name}
                            disabled
                            style={{ marginTop: 36 }}
                        />
                        <div className={classes.numberInputBottom}>
                            <NumberInput
                                value={item.total_count ? parseInt(item.total_count) : 0}
                                index={key}
                                maxNum={null}
                                action="labs"
                                disabled={true}
                            />
                        </div>
                    </CardContent>
                </Card>
            </div>
        ))
        )
    }

    const formValidationCheck = async (evt) => {
        const {
            assessments,
            courses,
            apprenticeships,
            labs
        } = assignLicenseForm;
        let isValidCourseCount = [];
        let isValidAsseCount = [];
        let isValidApprCount = [];
        const payload = {
            remove_assesments: removeAssessments,
            remove_courses: removeCourses,
            remove_apprenticeships: removeApprenticeships,
            remove_labs: removeLabs,
            status: user.status,
            customer_id: id || localStorage.getItem('cstmsrSaveFlow'),
            course_customer: (courses.length && courses[0]?.course_id) ? courses.map(itm => {
                if (itm?.course_id?.id && !itm.total_count) {
                    isValidCourseCount.push(itm);
                }
                return { ...itm, count: itm.total_count, course_id: itm.course_id.id };
            }) : [],
            assessment_customer: (assessments.length && assessments[0]?.assessment_id) ? assessments.map(itm => {
                if (itm?.assessment_id?.uuid && !itm.total_count) {
                    isValidAsseCount.push(itm);
                }
                return ({ ...itm, count: itm.total_count, assessment_id: itm.assessment_id.uuid })
            }) : [],
            apprenticeship_customer: (apprenticeships.length && apprenticeships[0].apprenticeship_id) ? apprenticeships.map(itm => {
                if (!itm.total_count) {
                    isValidApprCount.push(itm);
                }
                return ({ ...itm, count: itm.total_count, apprenticeship_id: itm.apprenticeship_id.uuid });
            }) : [],
            lab_customer: (labs.length && labs[0]?.lab_id) ? labs.map(itm => {
                let course = courses.find(crs => crs?.course_id?.id === itm.course_id);
                return {
                    ...itm,
                    count: course?.total_count || 0,
                    total_count: course?.total_count || 0,
                    lab_id: itm?.uuid || itm?.lab_id?.id || ''
                };
            }) : []
        };
        if (isValidAsseCount.length) {
            let asses = isValidAsseCount.map(cs => cs?.assessment_id?.name || '');
            notify("error", `You can't Assign ${asses.join(", ")} Assessment with 0 Count!`);
            return null;
        }
        if (isValidCourseCount.length) {
            let courses = isValidCourseCount.map(cs => cs?.course_id?.name || '');
            notify("error", `You can't Assign ${courses.join(", ")} Course with 0 Count!`);
            return null;
        }
        if (isValidApprCount.length) {
            let appris = isValidApprCount.map(cs => cs?.apprenticeship_id?.name || '');
            notify("error", `You can't Assign ${appris.join(", ")} Apprenticeship with 0 Count!`);
            return null;
        }
        try {
            setSubmitLoading(true);
            const result = await customerServices.assignCustomerLicence(payload, id || localStorage.getItem('cstmsrSaveFlow'));
            if (result && result.status) {
                if (result && result.message.includes('associated with user')) {
                    setSubmitLoading(false);
                    setRemoveCourses([]);
                    setRemoveAssessments([]);
                    setRemoveApprenticeships([]);
                    notify("error", "Some Courses/Assessments/Apprenticeships are already assigned with projects/users, You can't remove it, Please Unallocated from there and try.");
                    return getProjectDetails();
                } else {
                    localStorage.setItem('assign_lecense', true);
                    localStorage.setItem('refreshlic', true);
                    localStorage.setItem('getAllCustomer', true);
                    handleNext(evt);
                    setSubmitLoading(false);
                    notify("success", result.message);
                    if (id) {
                        localStorage.setItem('editstep', 2);
                    }
                }
            } else {
                setSubmitLoading(false);
                notify("error", (result && result.message) ? result.message : 'Something Went Wrong');
            }
        }
        catch (err) {
            setSubmitLoading(false);
            console.log("error", err);
        }
    }

    return (
        <React.Fragment>
            {(initialLoading || providerLoading) ? (
                <div className={classes.sectionLoaderWrap}>
                    <CircularProgress size={34} />
                </div>
            ) : null}
            {!(initialLoading || providerLoading) ? (
            <Grid container spacing={2} alignItems="stretch">
                <Grid item xs={12} sm={12} md={3} className={classes.cardGridItem}>
                    {getAssessments()}
                </Grid>
                <Grid item xs={12} sm={12} md={3} className={classes.cardGridItem}>
                    {getCourses()}
                </Grid>
                <Grid item xs={12} sm={12} md={3} className={classes.cardGridItem}>
                    {getApprenticeships()}
                </Grid>
                <Grid item xs={12} sm={12} md={3} className={classes.cardGridItem}>
                    {getLabs()}
                </Grid>
            </Grid>
            ) : null}
            <div className={onBorningClasses.buttons}>
                <div className={onBorningClasses.wrapper}>
                    {activeStep !== 0 && (
                        <Button
                            onClick={handleBack}
                            variant="contained"
                            color="primary"
                            className={onBorningClasses.cancelBtn}>
                            Back
                        </Button>
                    )}
                    <Button
                        type={"button"}
                        onClick={formValidationCheck}
                        variant="contained"
                        color="primary"
                        disabled={submitLoading}
                        className={onBorningClasses.button}
                    >
                        {submitLoading ? (
                            <CircularProgress
                                size={18}
                                className={classes.buttonProgress}
                            />
                        ) : 'Next'}
                    </Button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default React.memo(AssignLicence);